import {BRAND_NAME} from "@/constants.js";

export const getPermissions = () => {
    // Older browsers might not implement mediaDevices at all, so we set an empty object first
    if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
    }

    // Some browsers partially implement mediaDevices. We can't just assign an object
    // with getUserMedia as it would overwrite existing properties.
    // Here, we will just add the getUserMedia property if it's missing.
    if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
            // First get ahold of the legacy getUserMedia, if present
            const getUserMedia =
                navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            // Some browsers just don't implement it - return a rejected promise with an error
            // to keep a consistent interface
            if (!getUserMedia) {
                return Promise.reject(
                    new Error("getUserMedia is not implemented in this browser")
                );
            }

            // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
            return new Promise((resolve, reject) => {
                getUserMedia.call(navigator, constraints, resolve, reject);
            });
        };
    }
    navigator.mediaDevices.getUserMedia =
        navigator.mediaDevices.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia;

    return new Promise((resolve, reject) => {
        navigator.mediaDevices
            .getUserMedia({video: true, audio: true})
            .then(stream => {
                resolve(stream);
            })
            .catch(err => {
                reject(err);
                //   throw new Error(`Unable to fetch stream ${err}`);
            });
    });
};


export const createJavaScriptDateTime = (date, time) => {
    const specifiedDateTime = date + ' ' + time + ':00';
    const isoDateTime = specifiedDateTime.replace(' ', 'T');

    // Create a new Date object with the specified date and time in local time zone
    const dateTime = new Date(isoDateTime);
    return dateTime.toString();
}


export function convertTo12HourFormat(time24) {
    // Split the time into hours and minutes
    const [hours, minutes] = time24.split(':');

    // Convert hours part to a number
    const hoursNumeric = parseInt(hours, 10);

    // Determine AM or PM
    const period = hoursNumeric >= 12 ? 'PM' : 'AM';

    // Convert 24-hour time to 12-hour format
    const hours12 = hoursNumeric > 12 ? hoursNumeric - 12 : (hoursNumeric === 0 ? 12 : hoursNumeric);

    // Return the formatted time
    return `${hours12} ${period}`;
}

// handleError.js
export function handleFormErrors(error, setValidationErrors, setGeneralError) {
    // Clear existing errors
    setValidationErrors({});
    setGeneralError('');

    // Check if it's a Laravel validation error (422 Unprocessable Entity)
    if (error.response && error.response.status === 422) {
        setValidationErrors(error.response.data.errors || {});
    }

    // Check if it's a general error (e.g., 500 Internal Server Error or 400 Bad Request)
    else if (error.response && (error.response.status === 500 || error.response.status === 400)) {
        setGeneralError(error.response.data.message || 'An error occurred');
    }

    // Log or handle other types of errors as needed
    else {
        console.error('Unhandled Error:', error);
    }
}

export function  isMobileDevice() {
    // check based on window width
    if (typeof window === 'undefined') {
        return false;
    }
    return window.innerWidth <= 800;
}

export function wordpressPostContentAdapter(content) {
    // Regular expression to match 'http://blog.mockready.com' or 'https://blog.mockready.com'


    // Replace the URLs in the content
    const regex = /blog\.mockready\.com\/(?!wp-content)[^\s"]+/g;

    // Replacement URL
    const replacementUrl = "mockready.com/blog";

    // Replace the URLs in the content
    content = content.replace(regex, (match) => {
        return match.replace('blog.mockready.com', replacementUrl);
    });
    content = content.replaceAll('{{ BRAND_NAME }}', BRAND_NAME);
    return content;
}

export function isServer() {
    return typeof window === 'undefined';
}

function isMimeTypeSupported(mimeType) {
    return MediaRecorder.isTypeSupported(mimeType);
}


function isMP4MediaRecorderSupported() {
    const mimeType = 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"';
    return isMimeTypeSupported(mimeType);
}
function isWebMMediaRecorderSupported() {
    const mimeType = 'video/webm; codecs="vp8, opus"';
    return isMimeTypeSupported(mimeType);
}

export function getSupportedMediaRecorderType() {
    if (isMP4MediaRecorderSupported()) {
        return 'video/mp4';
    }
    if (isWebMMediaRecorderSupported()) {
        return 'video/webm';
    }
    return null;
}
export function getSupportedMediaRecorderTypeExtension() {
    if (isMP4MediaRecorderSupported()) {
        return 'mp4';
    }
    if (isWebMMediaRecorderSupported()) {
        return 'webm';
    }
    return null;
}

export function nextUserGuideStep(stepKey, userGuideSteps) {
    const nextStepIndex = userGuideSteps.findIndex(step => step.key === stepKey) + 1;
    return userGuideSteps[nextStepIndex] || null;
}

export function previousUserGuideStep(stepKey, userGuideSteps) {
    const previousStepIndex = userGuideSteps.findIndex(step => step.key === stepKey) - 1;
    return userGuideSteps[previousStepIndex] || null;
}
export function IsUserGuideStepValid(stepKey, userGuideSteps) {
    return userGuideSteps.findIndex(step => step.key === stepKey) !== -1;
}

export function speakText(text) {
      if ('speechSynthesis' in window) {
        var utterance = new SpeechSynthesisUtterance();
        utterance.voice = getBestVoice();
        utterance.rate = 1;
        utterance.pitch = 1;
        utterance.text = text;
        console.log(getBestVoice())
        window.speechSynthesis.speak(utterance);
      } else {
        alert('Sorry, your browser does not support speech synthesis.');
      }
}

export function stopSpeaking() {
    if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
    }
}

export function isSpeechSynthesisSupported() {
    return 'speechSynthesis' in window;
}

export function isSpeechRecognitionSupported() {
    return 'webkitSpeechRecognition' in window;
}

export function getBestVoice() {
    const preferredVoices = [
        'Microsoft Neerja Online (Natural) - English (India)',
        'Microsoft Neerja Online (Natural) - English (India)'

        ]
    const preferredVoicesLangs = [
        'en-IN',
        'en-US',
        'en-GB',
    ]
    const voices = window.speechSynthesis.getVoices();

    // try to find the preferred voice in order
    for (let i = 0; i < preferredVoicesLangs.length; i++) {
        const voice = voices.find(voice => voice.lang === preferredVoicesLangs[i]);
        if (voice) {
            return voice;
        }
    }
    // if no preferred voice is found, return the first voice
    return voices[0];
}

export function getVoices() {
    return window.speechSynthesis.getVoices();
}


export function convertStripeAmount(amount) {
    if (!amount) {
        return null
    }
    return (amount / 100).toFixed(2);
}
